export const LOCAL_STORAGE_LAST_USED_THEME_CONFIG = 'LAST_USED_THEME_CONFIG'
export const US_PRODUCTION_ORIGIN = 'https://calabriocloud.com'
export const USWEST2_PRODUCTION_ORIGIN = 'https://uswest2.calabriocloud.com'
export const AUS_PRODUCTION_ORIGIN = 'https://aus.calabriocloud.com'
export const EU_PRODUCTION_ORIGIN = 'https://eu.calabriocloud.com'
export const UK_PRODUCTION_ORIGIN = 'https://uk.calabriocloud.com'
export const CA_PRODUCTION_ORIGIN = 'https://ca.calabriocloud.com'
export const DEMO_ORIGIN = 'demo' //TODO - this will need to bbe updated when we know demo origins
export const PREVIEW_ORIGIN = 'https://preview.calabriocloud.com'
export const PARTNERS_ORIGIN = 'https://partners.calabriocloud.com'
export const PROPERTY_FILE_IMPLEMENTATION = 'PROPERTY_FILE'
export const LAUNCHDARKLY_IMPLEMENTATION = 'LAUNCH_DARKLY'
export const UNLOADED_IMPLEMENTATION = 'UNLOADED'
